import { render, staticRenderFns } from "./editIpt.vue?vue&type=template&id=24d61b92&scoped=true"
import script from "./editIpt.vue?vue&type=script&lang=js"
export * from "./editIpt.vue?vue&type=script&lang=js"
import style0 from "./editIpt.vue?vue&type=style&index=0&id=24d61b92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d61b92",
  null
  
)

export default component.exports